import React from 'react';
import 'LIBRARY/Components/Settings/DueDateNotification/DueDateNotification.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';


class RulesAndConfiguration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            outTime: '10:00 AM',
            animating: false,
            // linked institutes (null = loading, [] = none)
            linkedInstituteArray: null,
            // currently selected institute for which rules/settings are shown
            selectedInstituteId: null,
            // which institute row is expanded to show rules
            expandedInstituteId: null,
            selectedInstituteName: '',
            // settings array to demonstrate action button behaviour
            settings: [
                {
                    key: 'set_fix_library_out_time',
                    label: 'Set Fix Library Out Time',
                    desc: 'Once you set a fixed timeout, the out time must be',
                    status: false,
                    editMode: false,
                    prevStatus: false
                }
            ]
            ,
            // per-institute settings cache: { [iid]: [settings] }
            settingsByInstitute: {},
            // iids currently loading their settings
            loadingSettingsIids: []
            ,
            // when user clicks clock icon, focus time select for this iid
            focusTimeFor: null
        };
    }

    // Apply/save all pending changes for an institute
    applyAllPendingChanges = (iid) => {
        const settingsForIid = this.state.settingsByInstitute && this.state.settingsByInstitute[iid];
        if (!settingsForIid) return;

        settingsForIid.forEach((s, idx) => {
            if (s.editMode) {
                this.checkIfOldLeaveTypesAreConfiguredWithNow(idx, iid);
            }
        });
    }

    // when user selects an institute from the linked list, toggle expand and load its settings
    handleSelectInstitute = (iid, name) => {
        // toggle expansion; but also ensure settings are loaded for the institute
        if (this.state.expandedInstituteId === iid) {
            this.setState({ selectedInstituteId: null, selectedInstituteName: '', expandedInstituteId: null });
            return;
        }

        this.setState({ selectedInstituteId: iid, selectedInstituteName: name, expandedInstituteId: iid }, () => {
            // fetch settings for the selected institute if not loaded
            if (!this.state.settingsByInstitute[iid] && !this.state.loadingSettingsIids.includes(iid)) {
                this.apiCallToGetLeaveSettings(iid);
            }
        });
    }


    componentDidMount() {
        // fetch linked institutes (and their settings)
        this.GetAssignedInstituteList();  // assigned institute
    }

    //API CALL METHOD TO GET Institute
    GetAssignedInstituteList = async () => {
        // mark as loading
        this.setState({ linkedInstituteArray: null });

        const requestData = { 'facultyId': config.faculty_id, };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetFacultyAssignedInstituteList',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse && jsonResponse.expired) {
            setTimeout(() => {
                this.GetAssignedInstituteList();
            }, 1000);
            return;
        }

        if (jsonResponse && jsonResponse.success) {
            const apiResult = jsonResponse.APIResult || jsonResponse || {};
            const rawInstituteData = (apiResult && (apiResult.linkedInstituteData || apiResult.data)) || [];
            const linkedInstituteID = (apiResult && apiResult.linkedIidArray) || (jsonResponse && jsonResponse.linkedIidArray) || [];
            
            let linkedInstituteArray = rawInstituteData;
            if (Array.isArray(linkedInstituteID) && linkedInstituteID.length && rawInstituteData && !Array.isArray(rawInstituteData)) {
                try {
                    linkedInstituteArray = linkedInstituteID.map((id) => rawInstituteData[id] || rawInstituteData[String(id)] || { iid: id });
                } catch (e) {
                    linkedInstituteArray = Object.keys(rawInstituteData).map((k) => rawInstituteData[k]);
                }
            }

            this.setState({
                linkedInstituteArray: linkedInstituteArray,
                linkedInstituteArrayId: linkedInstituteID
            });
            // After we have the linked institutes, prefetch settings for each institute
            try {              
                let loadingSettingsIids = [];
                if (Array.isArray(linkedInstituteID) && linkedInstituteID.length) {
                    loadingSettingsIids = linkedInstituteID.slice();
                } else if (Array.isArray(linkedInstituteArray) && linkedInstituteArray.length) {
                    loadingSettingsIids = linkedInstituteArray.map(item => (item && (item.iid || item.institute_id || item.id)) || item).filter(Boolean);
                } else if (rawInstituteData && typeof rawInstituteData === 'object') {
                    loadingSettingsIids = Object.keys(rawInstituteData);
                }
                this.setState({ loadingSettingsIids });

                // fetch settings for each iid sequentially to avoid too many parallel requests
                for (const iid of loadingSettingsIids) {
                    // eslint-disable-next-line no-await-in-loop
                    await this.apiCallToGetLeaveSettings(iid);
                }
            } catch (e) {
                // ignore per-iid errors, they are handled in apiCallToGetLeaveSettings
            }

            return;
        }

        // error case: mark as empty array so loader hides
        this.setState({ linkedInstituteArray: [] });
    }

    // Toggle or input change handler
    // e: event or boolean, index: setting index, iid: institute id
    setApproverSettingsStatus = (e, index, iid) => {
        const targetIid = iid || this.state.selectedInstituteId;
        if (!targetIid) return;

        this.setState((prev) => {
            const settingsForIid = [...(prev.settingsByInstitute && prev.settingsByInstitute[targetIid] ? prev.settingsByInstitute[targetIid] : prev.settings)];
            const item = { ...settingsForIid[index] };

            if (item.key === 'number_of_day_for_auto_deduction') {
                // input change (string/number)
                item.status = e && e.target ? e.target.value : e;
                item.editMode = true;
            } else if (item.key === 'set_fix_library_out_time' && e && e.target) {
                // time dropdown change for this institute
                item.value = e.target.value;
                item.editMode = true;
            } else {
                // toggle behaviour: e may be event or boolean
                const newStatus = typeof e === 'boolean' ? e : !item.status;
                item.prevStatus = item.status;
                item.status = newStatus;
                item.editMode = true;
            }

            settingsForIid[index] = item;
            return { settingsByInstitute: { ...(prev.settingsByInstitute || {}), [targetIid]: settingsForIid } };
        });
    }

    // FUNCTION TO CALL API TO UPDATE A SETTING for a specific institute
    apiCallToUpdateLeaveSetting = async (index, iidParam) => {
        try {
            const iidToUse = iidParam || this.state.selectedInstituteId || config.institute_id;

            const settingsForIid = [...(this.state.settingsByInstitute && this.state.settingsByInstitute[iidToUse] ? this.state.settingsByInstitute[iidToUse] : this.state.settings)];
            const item = settingsForIid[index];
            // mark this setting as updating to disable inputs/icons for this institute
            settingsForIid[index] = { ...item, updating: true };
            this.setState((prev) => ({ settingsByInstitute: { ...(prev.settingsByInstitute || {}), [iidToUse]: settingsForIid } }));
            const status = item.status;
            const settingKey = item.key;

            // Prepare minimal request payload. Extend custom_value logic as needed.
            const requestData = {
                iid: iidToUse,
                facultyId: config.faculty_id,
                facility: settingKey,
                module: 'library',
                status: status ? true : false,
                // pass per-institute time/custom value when applicable
                custom_value: settingKey === 'set_fix_library_out_time' ? (item.value || item.prevCustomValue || '') : ''
            };

            const jsonResponse = await LibraryApiCall.makeApiCall(
                'AddUpdateManagementAccess',
                requestData,
                '/api/accessRequest/accessRequest.php'
            );

            if (jsonResponse && jsonResponse.success) {
                if (jsonResponse.APIResult && jsonResponse.APIResult.status === 'success') {
                    // mark saved locally and show success for this institute
                    settingsForIid[index] = { ...item, value: status, editMode: false, prevStatus: status, prevCustomValue: requestData.custom_value, updating: false };
                    // update state then re-fetch settings for this institute to display instant result
                    this.setState((prev) => ({
                        settingsByInstitute: { ...(prev.settingsByInstitute || {}), [iidToUse]: settingsForIid },
                        successModal: true,
                        successModalType: 'success',
                        successMessage: 'Settings updated successfully.'
                    }), () => {
                        // refresh the institute's settings to reflect any server-side normalization
                        this.apiCallToGetLeaveSettings(iidToUse);
                    });
                } else {
                    // clear updating flag for this institute
                    settingsForIid[index] = { ...item, updating: false };
                    this.setState((prev) => ({ settingsByInstitute: { ...(prev.settingsByInstitute || {}), [iidToUse]: settingsForIid }, successModal: true, successModalType: 'warning', successMessage: 'Settings is already updated.' }));
                }
            } else {
                // clear updating flag and show error for this institute
                settingsForIid[index] = { ...item, updating: false };
                this.setState((prev) => ({ settingsByInstitute: { ...(prev.settingsByInstitute || {}), [iidToUse]: settingsForIid }, animating: true, successModal: true, successModalType: 'error', successMessage: 'Something went wrong while submitting the data, please try again later.' }));
            }
        } catch (err) {
            const iidToUse = iidParam || this.state.selectedInstituteId || config.institute_id;
            const settingsForIid = [...(this.state.settingsByInstitute && this.state.settingsByInstitute[iidToUse] ? this.state.settingsByInstitute[iidToUse] : this.state.settings)];
            if (settingsForIid[index]) settingsForIid[index] = { ...settingsForIid[index], updating: false };
            this.setState((prev) => ({ settingsByInstitute: { ...(prev.settingsByInstitute || {}), [iidToUse]: settingsForIid }, animating: true, successModal: true, successModalType: 'error', successMessage: 'Something went wrong while submitting the data, please try again later.' }));
        }
    }


    // Save/confirm action: update local state and persist via API
    // index: setting index, iidParam: institute id to apply change for
    checkIfOldLeaveTypesAreConfiguredWithNow = (index, iidParam) => {
        const iid = iidParam || this.state.selectedInstituteId;
        this.setState((prev) => {
            const settingsForIid = [...(prev.settingsByInstitute && prev.settingsByInstitute[iid] ? prev.settingsByInstitute[iid] : prev.settings)];
            const item = { ...settingsForIid[index] };
            item.editMode = false;
            item.prevStatus = item.status;
            settingsForIid[index] = item;
            return { settingsByInstitute: { ...(prev.settingsByInstitute || {}), [iid]: settingsForIid } };
        }, () => {
            // after local update, call API to persist for this institute
            this.apiCallToUpdateLeaveSetting(index, iid);
        });
    }

    // Cancel and revert for a specific institute
    cancelSettingsUpdate = (index, iidParam) => {
        const iid = iidParam || this.state.selectedInstituteId;
        this.setState((prev) => {
            const settingsForIid = [...(prev.settingsByInstitute && prev.settingsByInstitute[iid] ? prev.settingsByInstitute[iid] : prev.settings)];
            const item = { ...settingsForIid[index] };
            item.status = item.prevStatus;
            item.editMode = false;
            settingsForIid[index] = item;
            const outTime = item.key === 'set_fix_library_out_time' ? (item.prevCustomValue || prev.outTime || '04:00 PM') : prev.outTime;
            return { settingsByInstitute: { ...(prev.settingsByInstitute || {}), [iid]: settingsForIid }, outTime };
        });
    }

    onTimeChange = (e, index) => {
        const newTime = e && e.target ? e.target.value : e;
        this.setState((prev) => {
            const settings = [...prev.settings];
            if (settings[index]) {
                settings[index] = { ...settings[index], editMode: true };
            }
            return { outTime: newTime, settings };
        });
    }

    // generate time options from 10:00 AM to 12:00 AM (midnight) every 30 minutes
    getTimeOptions = () => {
        const options = [];
        // start at 10:00 (600 minutes) to 24:00 (1440 minutes) inclusive
        const start = 10 * 60; // 10:00
        const end = 24 * 60; // 24:00 == 12:00 AM next day
        const step = 30; // minutes

        for (let mins = start; mins <= end; mins += step) {
            let h = Math.floor((mins / 60) % 24);
            let m = mins % 60;
            const period = h >= 12 ? 'PM' : 'AM';
            let displayHour = h % 12;
            if (displayHour === 0) displayHour = 12;
            const displayMinutes = m.toString().padStart(2, '0');
            options.push(`${displayHour}:${displayMinutes} ${period}`);
        }

        return options;
    }


    // API CALL TO GET SAVED SETTINGS FOR LIBRARY MODULE
    // iidParam: institute id to fetch settings for that institute
    apiCallToGetLeaveSettings = async (iidParam) => {
        if (!iidParam) return;

        // mark this iid as loading
        this.setState((prev) => ({
            loadingSettingsIids: Array.from(new Set([...(prev.loadingSettingsIids || []), iidParam]))
        }));

        const requestData = {
            iid: iidParam,
            moduleNameArray: ['library']
        };

        try {
            const jsonResponse = await LibraryApiCall.makeApiCall(
                'getManagementModuleWiseAccessList',
                requestData,
                '/api/accessRequest/accessRequest.php'
            );

            if (jsonResponse && jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToGetLeaveSettings(iidParam);
                }, 1000);
                return;
            }

            let settingsForInstitute = null;

            if (jsonResponse && jsonResponse.success) {
                const apiResult = jsonResponse.APIResult && jsonResponse.APIResult.moduleWiseKeyWiseObj;
                if (apiResult) {
                    const libObj = apiResult.library;
                    if (libObj) {
                        // build settings array from template for this institute
                        const settings = (this.state.settings || []).map((s) => ({ ...s }));
                        settings.forEach((setting, idx) => {
                            const key = setting.key;
                            const apiEntry = libObj[key];
                            if (apiEntry !== undefined && apiEntry !== null) {
                                if (typeof apiEntry === 'object') {
                                    if (apiEntry.hasOwnProperty('access')) {
                                        setting.status = apiEntry.access;
                                        setting.value = apiEntry.access;
                                        setting.prevStatus = apiEntry.access;
                                    }
                                    if (apiEntry.hasOwnProperty('custom_value') && apiEntry.custom_value !== null && apiEntry.custom_value !== '') {
                                        if (key === 'set_fix_library_out_time') {
                                            setting.prevCustomValue = apiEntry.custom_value;
                                            setting.value = apiEntry.custom_value;
                                            // per-institute time stored in setting.value
                                        } else if (key === 'number_of_day_for_auto_deduction') {
                                            setting.status = apiEntry.custom_value;
                                            setting.value = apiEntry.custom_value;
                                        }
                                    }
                                } else {
                                    setting.status = apiEntry;
                                    setting.value = apiEntry;
                                    setting.prevStatus = apiEntry;
                                }
                            }
                            settings[idx] = setting;
                        });

                        settingsForInstitute = settings;
                    }
                }
            }

            // store settings (or empty array) for this institute
            this.setState((prev) => {
                const next = { ...(prev.settingsByInstitute || {}) };
                next[iidParam] = settingsForInstitute || (this.state.settings || []).map(s => ({ ...s }));
                return {
                    settingsByInstitute: next,
                    loadingSettingsIids: (prev.loadingSettingsIids || []).filter(id => id !== iidParam)
                };
            });
        } catch (err) {
            this.setState((prev) => ({
                loadingSettingsIids: (prev.loadingSettingsIids || []).filter(id => id !== iidParam)
            }));
        }
    }

    // CLOSE THE SUCCESS /WARNING MODAL
    successModalVisibility = () => {
        this.setState({
            successModal: false,
        })
    }

    render() {
        const { outTime, enabled } = this.state;

        return (
            <>
                <div className="libraryComponents-container pr-4">
                    <div className='d-flex align-items-center flex-row'>
                        <button className="btn closeDetails" title="Click to visit back to settings" style={{ marginRight: '10px' }} onClick={() => this.props.closeRulesAndConfiguration()} >
                            <FontAwesomeIcon className="" icon={["fa", "angle-left"]} />
                        </button>
                        &nbsp;
                        <div className="mt-1">
                            <h3 style={{ fontSize: "28px" }}>Rules and Configuration</h3>
                        </div>
                    </div>

                    <div>
                        {/* Single table with 4 columns: Sr.No, Institute Name, Action, Rule */}
                        <table className="table table-hover table-bordered table-responsive-lg" style={{ border: '0.9px solid rgb(224, 232, 239)', marginTop: '25px' }}>
                            <thead>
                                <tr>
                                    <th style={{ padding: '15px', backgroundColor: 'rgb(245, 248, 250)', width: '60px' }}>Sr. No.</th>
                                    <th style={{ padding: '15px', backgroundColor: 'rgb(245, 248, 250)' }}>Institute Name</th>
                                    <th style={{ padding: '15px', backgroundColor: 'rgb(245, 248, 250)', textAlign: 'center', width: '140px' }}>Action</th>
                                    <th style={{ padding: '15px', backgroundColor: 'rgb(245, 248, 250)' }}>Rule</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.linkedInstituteArray === null ? (
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'center', padding: '30px' }}>
                                            <ButtonLoader />
                                        </td>
                                    </tr>
                                ) : (
                                    (() => {
                                        const list = this.state.linkedInstituteArray || [];

                                        const renderRow = (iid, name, idx) => {
                                            const settingsForIid = this.state.settingsByInstitute && this.state.settingsByInstitute[iid];
                                            const loading = this.state.loadingSettingsIids && this.state.loadingSettingsIids.includes(iid);

                                            return (
                                                <tr key={String(iid)}>
                                                    <td style={{ verticalAlign: 'middle', padding: '12px', width: '60px' }}>{idx + 1}</td>
                                                    <td style={{ padding: '12px' }}>{name}</td>
                                                    <td style={{ padding: '12px', textAlign: 'center', verticalAlign: 'middle' }}>
                                                        {loading ? (
                                                            <ButtonLoader />
                                                        ) : settingsForIid ? (
                                                            <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
                                                                {/* toggle using the Set Fix Library Out Time setting if available */}
                                                                {(() => {
                                                                    const timeIndex = (this.state.settings || []).findIndex(s => s.key === 'set_fix_library_out_time');
                                                                    const timeCell = settingsForIid && settingsForIid[timeIndex];
                                                                    return (
                                                                        <FontAwesomeIcon
                                                                            icon={["fa", timeCell && timeCell.status ? 'toggle-on' : 'toggle-off']}
                                                                            title={timeCell && timeCell.status ? 'Disable' : 'Enable'}
                                                                            style={{ fontSize: '20px', color: timeCell && timeCell.status ? '#28a745' : '#6c757d', cursor: 'pointer' }}
                                                                            onClick={() => {
                                                                                if (timeCell && !timeCell.updating) this.setApproverSettingsStatus(null, timeIndex, iid);
                                                                            }}
                                                                        />
                                                                    );
                                                                })()}


                                                            </div>
                                                        ) : (
                                                            <span style={{ color: '#6c757d' }}>-</span>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '12px' }}>
                                                        {loading && !settingsForIid ? (
                                                            <div style={{ textAlign: 'center' }}><ButtonLoader /></div>
                                                        ) : settingsForIid ? (
                                                            <div>
                                                                {(settingsForIid || []).map((cellData, sIndex) => (
                                                                    <div key={cellData.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #eef3f7' }}>
                                                                        <div style={{ flex: 1 }}>
                                                                            <div style={{ fontWeight: 600 }}>{cellData.label}</div>
                                                                            {/* <div style={{ color: '#6c757d', fontSize: 13 }}>{cellData.desc}{cellData.key === 'set_fix_library_out_time' ? ' ' + (cellData.desc || '') : ''}</div> */}
                                                                            <div style={{ color: '#6c757d', fontSize: 13 }}>
                                                                                    {cellData.key === 'set_fix_library_out_time' ? (
                                                                                        `Once you set a fixed timeout, the out time must be "${cellData.value || cellData.prevCustomValue || this.state.outTime}" and the system will automatically log out all visitors.`
                                                                                    ) : (
                                                                                        cellData.desc
                                                                                    )}
                                                                                </div>
                                                                        </div>
                                                                        <div style={{ width: 220, textAlign: 'right' }}>
                                                                            {cellData.key === 'set_fix_library_out_time' ? (
                                                                                <select autoFocus={this.state.focusTimeFor === iid} value={cellData.value || cellData.prevCustomValue || this.state.outTime} onChange={(e) => this.setApproverSettingsStatus(e, sIndex, iid)} disabled={cellData.updating || !cellData.status} style={{ padding: '6px 10px', maxHeight: '40px', borderRadius: 4, border: '1px solid #ced4da', background: cellData.updating || !cellData.status ? '#f5f5f5' : '#fff', marginRight: 8 }}>
                                                                                    {this.getTimeOptions().map((t) => (
                                                                                        <option key={t} value={t}>{t}</option>
                                                                                    ))}
                                                                                </select>
                                                                            ) : (
                                                                                <FontAwesomeIcon
                                                                                    icon={["fa", cellData.status ? 'toggle-on' : 'toggle-off']}
                                                                                    title={cellData.status ? 'Disable' : 'Enable'}
                                                                                    style={{ fontSize: '24px', color: cellData.status ? '#28a745' : '#6c757d', opacity: cellData.updating ? 0.5 : 1, cursor: cellData.updating ? 'not-allowed' : 'pointer', pointerEvents: cellData.updating ? 'none' : 'auto' }}
                                                                                    role="button"
                                                                                    tabIndex={cellData.updating ? -1 : 0}
                                                                                    onClick={() => { if (!cellData.updating) this.setApproverSettingsStatus(null, sIndex, iid); }}
                                                                                    onKeyDown={(e) => { if (!cellData.updating && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) this.setApproverSettingsStatus(null, sIndex, iid); }}
                                                                                />
                                                                            )}

                                                                            {cellData.editMode && cellData.status && (
                                                                                <span style={{ marginLeft: 8 }}>
                                                                                    {cellData.updating ? <ButtonLoader /> : null}
                                                                                    <FontAwesomeIcon
                                                                                        icon={['fas', 'check']}
                                                                                        size="lg"
                                                                                        title="Click to update the settings"
                                                                                        color='green'
                                                                                        style={{ cursor: cellData.updating ? 'not-allowed' : 'pointer', opacity: cellData.updating ? 0.5 : 1, marginLeft: 12, pointerEvents: cellData.updating ? 'none' : 'auto' }}
                                                                                        role="button"
                                                                                        tabIndex={cellData.updating ? -1 : 0}
                                                                                        onClick={() => { if (!cellData.updating) this.checkIfOldLeaveTypesAreConfiguredWithNow(sIndex, iid); }}
                                                                                        onKeyDown={(e) => { if (!cellData.updating && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) this.checkIfOldLeaveTypesAreConfiguredWithNow(sIndex, iid); }}
                                                                                    />
                                                                                    <FontAwesomeIcon
                                                                                        icon={['fas', 'times']}
                                                                                        size="lg"
                                                                                        title="Click to cancel update"
                                                                                        color='red'
                                                                                        style={{ cursor: cellData.updating ? 'not-allowed' : 'pointer', opacity: cellData.updating ? 0.5 : 1, marginLeft: 8, pointerEvents: cellData.updating ? 'none' : 'auto' }}
                                                                                        role="button"
                                                                                        tabIndex={cellData.updating ? -1 : 0}
                                                                                        onClick={() => { if (!cellData.updating) this.cancelSettingsUpdate(sIndex, iid); }}
                                                                                        onKeyDown={(e) => { if (!cellData.updating && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) this.cancelSettingsUpdate(sIndex, iid); }}
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <div style={{ color: '#6c757d' }}>No rules</div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        };

                                        const rows = [];
                                        if (!Array.isArray(list) && typeof list === 'object') {
                                            Object.keys(list).forEach((key, idx) => {
                                                const val = list[key] || {};
                                                const iid = val.iid || val.institute_id || key;
                                                const name = val.institute_name || val.instituteName || val.name || val.institute || String(val);
                                                rows.push(renderRow(iid, name, idx));
                                            });
                                        } else {
                                            (list || []).forEach((inst, idx) => {
                                                const iid = inst && (inst.iid || inst.institute_id || inst.id) || idx;
                                                const name = inst && (inst.institute_name || inst.instituteName || inst.name || inst.institute) || String(inst);
                                                rows.push(renderRow(iid, name, idx));
                                            });
                                        }

                                        return rows;
                                    })()
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.successModalVisibility}
                    />
                }
            </>
        )
    }
}

export default RulesAndConfiguration;